module.exports = __webpack_public_path__ + "static/media/remove_mobile.71ff4911.svg";